import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getChannelForWidget } from '@wix/wix-vod-shared/common';
import {
  toggleShareChannelOverlay,
  toggleShareVideoOverlay,
} from '../../../redux/actions/share-overlay';
import { getVideoById } from '../../../selectors/videos';
import { getPublicVideo } from '../../../redux/actions/channel/video/get';
import ShareOverlay from '../../../containers/share-overlay/share-overlay';
import styles from './share-view.scss';
import { logBi } from '../../../worker/actions/bi';

const mapStateToProps = (state, props) => ({
  channelData: getChannelForWidget(state),
  video: getVideoById(state, props.match.params.videoId),
});

const mapDispatchToProps = {
  toggleShareChannelOverlay,
  toggleShareVideoOverlay,
  getPublicVideo,
  logBi,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class ShareView extends React.Component {
    static propTypes = {
      channelData: PropTypes.object.isRequired,
      match: PropTypes.object.isRequired,
      video: PropTypes.object,
      getPublicVideo: PropTypes.func.isRequired,
      toggleShareChannelOverlay: PropTypes.func.isRequired,
      toggleShareVideoOverlay: PropTypes.func.isRequired,

      close: PropTypes.func.isRequired,
    };

    componentDidMount() {
      const {
        match: {
          params: { videoId },
        },
        channelData,
        getPublicVideo,
      } = this.props;

      const getVideoPromise = videoId
        ? getPublicVideo(channelData.id, videoId)
        : Promise.resolve();

      getVideoPromise.then(() => {
        this.toggleShare();
      });

      this.props.logBi('widget.vid.share.displayed', {
        channelID: channelData.id,
        origin: 'on_site',
      });
    }

    toggleShare() {
      const {
        match: {
          params: { videoId },
        },
        toggleShareChannelOverlay,
        toggleShareVideoOverlay,
      } = this.props;

      if (videoId) {
        toggleShareVideoOverlay();
      } else {
        toggleShareChannelOverlay();
      }
    }

    render() {
      const { channelData, video, close } = this.props;

      return (
        <div className={styles.container}>
          <ShareOverlay
            channelData={channelData}
            onClosed={close}
            canShareVideo={Boolean(video)}
            videoItem={video}
          />
        </div>
      );
    }
  },
);
